import { Box, IconButton, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { InternalIndicator } from "lib/@components/save-indicator/internal-indicator"
import { createSlot } from "lib/@components/slot/create-slot"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export const AuthoringReviewSectionActions = createSlot("AuthoringReviewSectionActions")
export const AuthoringReviewSectionStatus = createSlot("AuthoringReviewSectionStatus")

export function AuthoringReviewSection({ title, readOnly, editor, saveId, dataCy = "authoring-review-section" }) {
    const { isEditing = false, isCollapsed = false, onToggleCollapsed } = useBoundContext()
    // An active editor always shows in full, regardless of collapse state.
    const showBody = isEditing || !isCollapsed
    const toggleIcon = isCollapsed ? "mdi:chevron-right" : "mdi:chevron-down"
    const toggleLabel = `${isCollapsed ? "Expand" : "Collapse"} ${title}`
    return (
        <Box sx={{ backgroundColor: "action.hover", borderRadius: 2, p: 2 }} data-cy={dataCy}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <If truthy={Boolean(onToggleCollapsed) && !isEditing}>
                        <IconButton
                            size="small"
                            onClick={onToggleCollapsed}
                            aria-label={toggleLabel}
                            aria-expanded={!isCollapsed}
                            data-cy={`${dataCy}-collapse-toggle`}
                        >
                            <Iconify icon={toggleIcon} width={20} />
                        </IconButton>
                    </If>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {title}
                    </Typography>
                    <AuthoringReviewSectionStatus.Slot />
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1.5}>
                    <If truthy={isEditing}>
                        <InternalIndicator id={saveId} />
                    </If>
                    <Stack direction="row" spacing={0.5}>
                        <AuthoringReviewSectionActions.Slot />
                    </Stack>
                </Stack>
            </Stack>

            <If truthy={showBody}>
                <Box mt={1.5} data-cy={`${dataCy}-content`}>
                    <If truthy={isEditing}>
                        {editor}
                        <Else>{readOnly}</Else>
                    </If>
                </Box>
            </If>
        </Box>
    )
}
